import { render, staticRenderFns } from "./Year10.vue?vue&type=template&id=7602f045&scoped=true&"
import script from "./Year10.vue?vue&type=script&lang=js&"
export * from "./Year10.vue?vue&type=script&lang=js&"
import style0 from "./Year10.vue?vue&type=style&index=0&id=7602f045&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7602f045",
  null
  
)

export default component.exports